<div class="digital-use">
  <div class="digital-use__header">
    <p>Acessos nos últimos 30 dias</p>
    <p>Séries</p>
    <p>Total de Usuários</p>
  </div>

  <div *ngIf="products && products.length > 0">
    <div class="digital-use__products-list">
      <div class="digital-use__product" *ngFor="let product of products; let i = index">

        <div class="product__brand">
          <span class="product__index">{{i + 1}}</span>

          <img height="52" width="52" [src]="product.urlImage" />

          <seb-progress-bar [label]="product.productName" [percentage]="product.percentage" [showPercentage]="true"
            [value]="product.totalAccess" [backgroundColor]="product.productColor" [ngStyle]="{'margin': 0}"
            [progressBarHeight]="26">
          </seb-progress-bar>
        </div>

        <span class="header__title">Séries</span>
        <div class="product__badges-list">
          <span class="product__badge" *ngFor="let grade of product.grades"
            [ngStyle]="{'background-color': getSplitedColors(grade.gradeColor).tagBackgroundColor, 'color': getSplitedColors(grade.gradeColor).tagTextColor}">
            {{grade.gradeKey}}
          </span>
        </div>

        <span class="header__title">Total de Usuários</span>
        <div class="product__total">{{product.totalUsers}}</div>
      </div>
      <!--/ digital-use__product -->
    </div>
    <!--/ digital-use__products-list -->
  </div>
</div>
